import { BaseHook } from './base.hook';

export class MailAddressHook extends BaseHook {

  static path = 'PersonalInformation.mailAddressDifferent';

  static execute(path, value, actions) {
    if (value === false) {
      actions.deleteData('PersonalInformation.mailingAddress');
    }
  }
}
